import { useEffect, useState, useMemo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getDateTime, SessionKeys } from "../../../utils/AppUtils";
import { useDispatch, useSelector } from "react-redux";
import CONFIG from "../../../utils/config";
import {
  getAnyTotalReport,
  getOnboardingCompletionReport,
  getAnyTotalReportClear,
  getProfileCompletionReport,
  getProfileCompletionReportClear,
  getCoeRea,
  getCoeReaResClear,
  getCoeOffices,
  getCoeOfficesResClear,
  getCoeManagers,
  getCoeManagersResClear,
  getCoeTrendCurve,
  getCoeTrendCurveResClear,
  usageReport,
  getSavedFilterDataResponseClearById,
  getSavedFilterDataById,
  usageReportClear,
} from "../../../redux/reports/actions";
import _ from "lodash";
import PieChartComponent from "../ReportsComponents/PieChartComponent";
import ReportTableOnboard from "../ReportsComponents/ReportTableOnboard";
import { useNavigate, useLocation } from "react-router-dom";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import ManagerReportSecCoe from "../ReportsComponents/ManagerReportSecCoe";
import OfficeSectionCoe from "../ReportsComponents/OfficeSectionCoe";
import Loader from "../../Loader/Loader";
import CompletionTrendGraph from "../ReportsComponents/CompletionTrendGraph";
import { Spinner } from "react-bootstrap";
import ReportTableCoe from "../ReportsComponents/ReportTableCoe";
import AlertModalReports from "../ReportsComponents/alertModalReports";
import ReportHeaderComponent from "../layout/ReportHeaderComponent";
import ReportExportButtonComponent from "../layout/ReportExportButtonComponent";
import ReportFiltersComponent from "../layout/ReportFiltersComponent";
import DonutTrendChartComponent from "../layout/DonutTrendChartComponent";
import moment from "moment";
import StaticUtils from "../../../utils/StaticUtils";
import * as XLSX from "xlsx";
import ReportTableSystemUsage from "../ReportsComponents/ReportTableSystemUsage";
import { isAndroid, isIOS } from "react-device-detect";
import ConfirmModal from "../../modal/ConfirmModal";
import { useTranslation } from "react-i18next";
const SystemUsageReportHomeSection = (props) => {
  const { isMobile } = props;

  let location = useLocation();
  const { t } = useTranslation();
  console.log("state---", location.state?.selectedFilters); // Access the state

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const filterId = params.get("filters_id");
  const backbutton = params.get("backbutton");
  const authBroker = useSelector((state) => state.auth.authBroker);
  const authIframeBroker = useSelector((state) => state.auth.authIframeBroker);

  const [savedFiltersDataById, setSavedFiltersDataById] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const fileName = "SystemUsageReport";
  const [confirmModal, setConfirmModal] = useState(false);
  const [crsCompltTrendValues, setCrsCompltTrendValues] = useState([]);
  const [filterYearData, setFilterYearData] = useState([]);

  const [isView, setIsView] = useState("table");
  const [type, setType] = useState("pie");
  const [canShow, setCanShow] = useState(false);
  const [isLoaded, setIsLoaded] = useState(true);
  const [imgLoader, setImgLoader] = useState(true);
  const [reaList, setReaList] = useState([]);
  const [limitStatus, setLimitStatus] = useState("");
  const [loadSpin, setLoadSpin] = useState(true);
  const FILTER_BY = [
    { id: 0, value: "Select" },
    { id: 1, value: "Progress" },
    // { id: 1, value: "Learning Points" },
    // { id: 3, value: "Learning Hours" },
  ];
  // console.log("Thhh", overAllDataRes?.payload?.payload?.stats);
  const [statusFilterData] = useState([
    "Completed",
    "In Progress",
    "NotStarted",
  ]);
  const [profileReports, setProfileReports] = useState([]);
  const [totalRea, setTotalRea] = useState([]);
  const [profileReportsFilter, setProfileReportsFilter] = useState([]);

  // const profileReportRes = useSelector((state) => state.report?.profileReport);
  const usageReportRes = useSelector((state) => state?.report?.usageReportRes);
  console.log("usage reports", usageReportRes);
  const d = new Date();
  let year = d.getFullYear();
  const [trendYear, setTrendYear] = useState(year);
  const anyTotalReportRes = useSelector(
    (state) => state.report?.anyTotalReport
  );
  const coeReaSectRes = useSelector((state) => state.report?.coeReportRea);

  const coeOfficesSectRes = useSelector(
    (state) => state.report?.coeReportOffices
  );
  const coeTrendCurveRes = useSelector((state) => state.report?.coeTrend);
  // const crsCompletionTrendRes = useSelector(
  //   (state) => state.report.complianceCompletionTrend
  // );
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecord, setTotalRecord] = useState(0);
  const [legends, setLegends] = useState([]);
  const [series, setSeries] = useState([]);
  const [counter, setCounter] = useState(1);
  const [officeCounter, setOfficeCounter] = useState(1);
  const [managerCounter, setManagerCounter] = useState(1);
  const [filterBy, setFilterBy] = useState(FILTER_BY[0].value);
  const [actualCoursesList, setActualCoursesList] = useState([]);
  const [totalCountRea, setTotalCountRea] = useState("");
  const [showModalMsg, setShowModalMsg] = useState(
    "Available Real Estate Agents limit reached!"
  );
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const userDetailIframe = useSelector((state) => state.user.userDetailIframe);
  const [userDetails, setUserDetails] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isExpand, setIsExpand] = useState(false);

  const [selectedFilters, setSelectedFilters] = useState({
    dateRange: { start: "", end: "" },
    selectedProviderList: [],
    selectedOfficeList: [],
    selectedManagerCoachList: [],
    check: false,
    selectedCourseList: [],
    selectedTeamMatesList: [],
    selectedBrokerageList: [],
    selectedRole: [],
    selectedAgentStatus: [1],
    clickedApply: false,
  });
  const [showFilters, setShowFilters] = useState({
    reportingPeriod: false,
    provider: false,
    offices: true,
    role: false,
    reportingTo: false,
    learningContentType: false,
    learningContent: false,
    agents: true,
    status: false,
    dojBrokerage: true,
    agentStatus: true,
    roleFilter: {
      manager: true,
      guest: true,
      all: true,
      instructor: false,
      SystemUsageReports: true,
      rea: true,
    },
  });
  const [reaIds, setReaIds] = useState([]);
  const [officeIds, setOfficeIds] = useState([]);
  const [managerIds, setManagerIds] = useState([]);
  const [statusAPI, setStatusAPI] = useState([
    "completed",
    "in-progress",
    "not-started",
  ]);
  const [Role, setRole] = useState([]);
  const [dojRange, setdojRange] = useState({ start: "", end: "" });
  const [officeLabel, setOfficeLabel] = useState("");

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      if (
        !_.isEmpty(authBroker.payload?.user?.config) &&
        authBroker.payload?.user?.config.office_name
      ) {
        setOfficeLabel(authBroker.payload?.user?.config.office_name);
      } else {
        setOfficeLabel("Office Name");
      }
    }
  }, [authBroker]);

  useEffect(() => {
    if (!_.isEmpty(authIframeBroker)) {
      // alert(JSON.stringify(authIframeBroker.payload.user.config))
      if (
        !_.isEmpty(authIframeBroker.payload?.user?.config) &&
        authIframeBroker.payload?.user?.config.office_name
      ) {
        setOfficeLabel(authIframeBroker.payload?.user?.config.office_name);
      } else {
        setOfficeLabel("Office Name");
      }
    }
  }, [authIframeBroker]);

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      if (authBroker.status === "success") {
        if (authBroker.payload && authBroker.payload?.user) {
          if (authBroker.payload?.user?.is_corporate) {
            setShowFilters({
              reportingPeriod: false,
              provider: false,
              offices: true,
              role: false,
              reportingTo: false,
              learningContentType: false,
              learningContent: false,
              agents: true,
              status: false,
              dojBrokerage: true,
              brokerages: true,
              agentStatus: true,
              roleFilter: {
                manager: true,
                guest: true,
                all: true,
                instructor: false,
                SystemUsageReports: true,
                rea: true,
              },
            });
            setIsExpand(true);
          }
        }
      }
    }
  }, [authBroker]);

  useEffect(() => {
    if (!_.isEmpty(authIframeBroker)) {
      if (authIframeBroker.payload && authIframeBroker.payload?.user) {
        if (authIframeBroker.payload?.user?.is_corporate) {
          setShowFilters({
            reportingPeriod: false,
            provider: false,
            offices: true,
            role: false,
            reportingTo: false,
            learningContentType: false,
            learningContent: false,
            agents: true,
            status: false,
            dojBrokerage: true,
            brokerages: true,
            agentStatus: true,
            roleFilter: {
              manager: true,
              guest: true,
              all: true,
              instructor: false,
              SystemUsageReports: true,
              rea: true,
            },
          });
          setIsExpand(true);
        }
      }
    }
  }, [authIframeBroker]);

  useEffect(() => {
    console.log("ss-- loc", savedFiltersDataById?.filter_content);
    if (!_.isEmpty(savedFiltersDataById?.filter_content)) {
      setIsLoading(true);

      let reaIds =
        savedFiltersDataById?.filter_content.selectedTeamMatesList.map(
          (obj) => {
            return obj.user_id;
          }
        );

      let officeIds =
        savedFiltersDataById?.filter_content.selectedOfficeList.map((obj) => {
          console.log("GET OFFICE IDS get", obj);
          return obj.office_id;
        });

      let managerIds =
        savedFiltersDataById?.filter_content.selectedManagerCoachList.map(
          (obj) => {
            return obj.id;
          }
        );

      let userStatus = 4;
      if (_.isArray(savedFiltersDataById?.filter_content.selectedAgentStatus)) {
        if (
          savedFiltersDataById?.filter_content.selectedAgentStatus.includes(
            3
          ) ||
          (savedFiltersDataById?.filter_content.selectedAgentStatus.includes(
            1
          ) &&
            savedFiltersDataById?.filter_content.selectedAgentStatus.includes(
              2
            ))
        ) {
          userStatus = 3;
        } else if (
          savedFiltersDataById?.filter_content.selectedAgentStatus.includes(1)
        ) {
          userStatus = 1;
        } else if (
          savedFiltersDataById?.filter_content.selectedAgentStatus.includes(2)
        ) {
          userStatus = 2;
        }
      }
      dispatch(
        usageReport({
          module: "getUsageReport",
          postData: {
            token: isMobile
              ? localStorage.getItem(SessionKeys.API_TOKEN)
              : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            rea_ids: reaIds,
            office_ids: officeIds,
            manager_ids: managerIds,
            role: savedFiltersDataById?.filter_content.selectedRole,
            search: "",
            page: "",
            page_size: "",
            date_range: savedFiltersDataById?.filter_content?.dojRange,
            user_status: userStatus,
            brokerage: savedFiltersDataById.selectedBrokerageList,
          },
        })
      );
    }
  }, [savedFiltersDataById]);

  useEffect(() => {
    if (filterId) {
      getSavedFiltersDataByIdFunc();
    }
    return () => {
      dispatch(getSavedFilterDataResponseClearById());
    };
  }, [filterId]);

  const getSavedFiltersDataByIdFunc = () => {
    setIsLoading(true);
    dispatch(
      getSavedFilterDataById({
        module: "getSavedFiltersDataById",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          id: filterId,
        },
      })
    );
  };

  const getSavedFiltersDataResponseById = useSelector(
    (state) => state.report.savedFilterDataById
  );

  useEffect(() => {
    if (!_.isEmpty(getSavedFiltersDataResponseById)) {
      if (getSavedFiltersDataResponseById?.status === "success") {
        setSavedFiltersDataById(
          getSavedFiltersDataResponseById?.payload?.payload[0]
        );
      } else {
        setSavedFiltersDataById("");
      }
    }
  }, [getSavedFiltersDataResponseById]);

  useEffect(() => {
    // console.log("from--".fromDashboard);
    // if (fromDashboard) {
    // } else {
    console.log("ss-- dispatch", !filterId);
    if (
      (!filterId || selectedFilters?.clickedApply) &&
      (authBroker.payload?.user || authIframeBroker.payload?.user) &&
      !(
        authBroker.payload?.user?.is_corporate ||
        authIframeBroker.payload?.user?.is_corporate
      )
    ) {
      loadAllApi();
    }
    // }
  }, [dispatch]);

  useEffect(() => {
    // console.log('userDetailRes: ', userDetailRes)
    if (isMobile) {
      if (!_.isEmpty(userDetailIframe?.payload?.payload)) {
        setUserDetails(userDetailIframe?.payload?.payload);
      }
    } else {
      if (!_.isEmpty(userDetailRes?.payload?.payload)) {
        setUserDetails(userDetailRes?.payload?.payload);
      }
    }
  }, [userDetailRes, userDetailIframe, isMobile]);

  useEffect(() => {
    console.log("selected filters1", selectedFilters);
  }, [selectedFilters]);
  useEffect(() => {
    console.log("GET OFFICE IDS - ", officeIds);
  }, [officeIds]);

  let PageSize = 20;

  useEffect(() => {
    console.log("selected filter", selectedFilters);
    if (authBroker?.payload?.user || authIframeBroker?.payload?.user) {
      if (
        authBroker.payload?.user?.is_corporate ||
        authIframeBroker.payload?.user?.is_corporate
      ) {
        if (selectedFilters.clickedApply) {
          if (selectedFilters?.selectedBrokerageList?.length == 0) {
            setIsLoading(false);
            setConfirmModal(true);
          } else {
            setCounter(1);
            setOfficeCounter(1);
            setManagerCounter(1);
            setOfficeIds(
              selectedFilters.selectedOfficeList.map((obj) => {
                console.log("GET OFFICE IDS get", obj);
                return obj.office_id;
              })
            );

            setReaIds(
              selectedFilters.selectedTeamMatesList.map((obj) => {
                return obj.user_id;
              })
            );

            setManagerIds(
              selectedFilters.selectedManagerCoachList.map((obj) => {
                return obj.id;
              })
            );

            setRole(selectedFilters.selectedRole);
            setStatusAPI(selectedFilters.selectedStatus);
            setdojRange(selectedFilters.dojRange);
            setIsLoading(true);
            getTableReport();
          }
        } else {
          setIsLoading(false);
          setUsageReports([]);
        }
      } else if (
        (!_.isEmpty(selectedFilters) && !filterId) ||
        selectedFilters?.clickedApply
      ) {
        setCounter(1);
        setOfficeCounter(1);
        setManagerCounter(1);
        setOfficeIds(
          selectedFilters.selectedOfficeList.map((obj) => {
            console.log("GET OFFICE IDS get", obj);
            return obj.office_id;
          })
        );

        setReaIds(
          selectedFilters.selectedTeamMatesList.map((obj) => {
            return obj.user_id;
          })
        );

        setManagerIds(
          selectedFilters.selectedManagerCoachList.map((obj) => {
            return obj.id;
          })
        );

        setRole(selectedFilters.selectedRole);
        setStatusAPI(selectedFilters.selectedStatus);
        setdojRange(selectedFilters.dojRange);
        setIsLoading(true);
      }
    }
  }, [selectedFilters, authBroker]);

  useEffect(() => {
    //   console.log("ss-- change");
    if (
      (!filterId || selectedFilters?.clickedApply) &&
      (authBroker.payload?.user || authIframeBroker.payload?.user) &&
      !(
        authBroker.payload?.user?.is_corporate ||
        authIframeBroker.payload?.user?.is_corporate
      )
    ) {
      loadAllApi();
    }
  }, [reaIds, officeIds, statusAPI, Role, selectedFilters]);

  //   useEffect(() => {
  //     getREADATA();
  //   }, [counter]);

  //   useEffect(() => {
  //     getOfficeData();
  //   }, [officeCounter]);

  //   useEffect(() => {
  //     getManagerData();
  //   }, [managerCounter]);

  //   useEffect(() => {
  //     getTrendData();
  //   }, [trendYear]);

  function setCount(counter, setCounter) {
    return setCounter(counter + 1);
  }
  const [usageReports, setUsageReports] = useState([]);
  const [usageReportsFilter, setusageReportsFilter] = useState([]);

  const currentTableData = useMemo(() => {
    if (usageReports !== null) {
      const firstPageIndex = (currentPage - 1) * PageSize;
      const lastPageIndex = firstPageIndex + PageSize;
      setCanShow(true);
      return usageReports.slice(firstPageIndex, lastPageIndex);
    }
  }, [currentPage, usageReports]);

  // *******************************//
  //   useEffect(() => {
  //     if (!_.isEmpty(coeReaSectRes)) {
  //       setLoadSpin(false);
  //       setLimitStatus(coeReaSectRes?.status);
  //       if (coeReaSectRes?.status === "success") {
  //         let allData = coeReaSectRes?.payload?.payload?.real_estate_agents;
  //         setTotalRea(coeReaSectRes?.payload?.payload);
  //         let temparr = _.cloneDeep(reaList);
  //         if (counter === 1) {
  //           temparr = [];
  //         }
  //         setReaList([...temparr, ...allData]);
  //         getCoeReaResClear();
  //       }
  //     }
  //   }, [coeReaSectRes]);

  //   useEffect(() => {
  //     setCounter(1);
  //     setReaList([]);
  //     return () => {
  //       dispatch(getCoeReaResClear());
  //     };
  //   }, []);

  //   useEffect(() => {
  //     // setCrsCompltTrendValues([])
  //     return () => {
  //       dispatch(getCoeTrendCurveResClear());
  //     };
  //   }, []);
  //   useEffect(() => {
  //     if (!_.isEmpty(coeTrendCurveRes)) {
  //       if (coeTrendCurveRes?.status === "success") {
  //         setImgLoader(false);
  //         let allData = [];
  //         allData = coeTrendCurveRes?.payload?.payload?.completion_trend;
  //         setCrsCompltTrendValues(Object.values(allData));
  //         setFilterYearData(coeTrendCurveRes?.payload?.payload?.year);
  //         dispatch(getCoeTrendCurveResClear());
  //       }
  //     }
  //   }, [coeTrendCurveRes]);

  // useEffect(() => {
  //     if (!_.isEmpty(anyTotalReportRes)) {

  //         setIsLoaded(false);

  //         let sortedData = [];
  //         let legends = [];
  //         let series = [];
  //         if (anyTotalReportRes?.status === "success") {
  //             setIsLoading(false);
  //             const reportData = anyTotalReportRes?.payload?.payload?.user_data;
  //             setProfileReports(reportData);
  //             setProfileReportsFilter(reportData);
  //             if (statusFilterData.includes("Completed")) {
  //                 let completedCount = reportData?.filter((data) => data.status === "Completed").length
  //                 series.push(
  //                     reportData?.filter((data) => data.status === "Completed").length
  //                 );
  //                 legends.push(`Completed (${completedCount})`);
  //             }
  //             if (statusFilterData.includes("In Progress")) {
  //                 let inprogressCount = reportData?.filter((data) => data.status === "In Progress").length
  //                 series.push(
  //                     reportData?.filter((data) => data.status === "In Progress").length
  //                 );
  //                 legends.push(`In Progress(${inprogressCount})`);
  //             }
  //             if (statusFilterData.includes("NotStarted")) {
  //                 let notStartedCount = reportData?.filter((data) => data.status === "NotStarted").length
  //                 series.push(
  //                     reportData?.filter((data) => data.status === "NotStarted").length
  //                 );
  //                 legends.push(`Yet to start (${notStartedCount})`);
  //             }

  //             if (legends.length < 3) {
  //                 legends.push("Others");

  //                 series.push(totalRecord - _.sum(series));
  //             }
  //             setLegends(legends);
  //             setSeries(series);
  //             setCurrentPage(1);
  //         } else {
  //             setProfileReports([]);
  //             setProfileReportsFilter([]);
  //             setCanShow(false);
  //             setIsLoading(false);
  //         }
  //         dispatch(getAnyTotalReportClear());
  //     }
  // }, [anyTotalReportRes]);

  useEffect(() => {
    if (!_.isEmpty(usageReportRes)) {
      if (usageReportRes?.status === "success") {
        setIsLoading(false);
        const usageReport = usageReportRes?.payload?.payload;
        setUsageReports(usageReport);
        setusageReportsFilter(usageReport);
        setCurrentPage(1);
      } else {
        setUsageReports([]);
        setIsLoading(false);
        setCanShow(false);
      }
      dispatch(usageReportClear());
    }
  }, [usageReportRes]);

  const loadAllApi = () => {
    // getREADATA();
    // getTrendData();
    getTableReport();
    // getOfficeData();
    // getManagerData();
    setReaList([]);
  };

  const getREADATA = () => {
    console.log("GET OFFICE IDS", officeIds);
    // GET REA DATA FOR COE REPORT
    dispatch(
      getCoeRea({
        module: "getCoeReportRea",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          rea_ids: reaIds,
          office_ids: officeIds,
          manager_uids: managerIds,
          stat: statusAPI,
          limit: counter,
        },
      })
    );
  };

  const getTrendData = () => {
    // GET TREND DATA FOR COE REPORT
    dispatch(
      getCoeTrendCurve({
        module: "getCoeReporTrend",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          rea_ids: reaIds,
          office_ids: officeIds,
          manager_ids: managerIds,
          stat: statusAPI,
          year: _.toNumber(trendYear),
        },
      })
    );
  };

  const getTableReport = () => {
    let userStatus = 4;
    if (_.isArray(selectedFilters.selectedAgentStatus)) {
      if (
        selectedFilters.selectedAgentStatus.includes(3) ||
        (selectedFilters.selectedAgentStatus.includes(1) &&
          selectedFilters.selectedAgentStatus.includes(2))
      ) {
        userStatus = 3;
      } else if (selectedFilters.selectedAgentStatus.includes(1)) {
        userStatus = 1;
      } else if (selectedFilters.selectedAgentStatus.includes(2)) {
        userStatus = 2;
      }
    }
    dispatch(
      usageReport({
        module: "getUsageReport",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          rea_ids: selectedFilters.selectedTeamMatesList.map(
            (obj) => obj.user_id
          ),
          office_ids: selectedFilters.selectedOfficeList.map(
            (obj) => obj.office_id
          ),
          manager_ids: selectedFilters.selectedManagerCoachList.map(
            (obj) => obj.id
          ),
          role: savedFiltersDataById?.filter_content?.selectedRole,
          search: "",
          page: "",
          page_size: "",
          date_range: dojRange,
          user_status: userStatus,
          brokerage: selectedFilters?.selectedBrokerageList,
        },
      })
    );
  };

  const getOfficeData = () => {
    // GET OFFICE DATA
    dispatch(
      getCoeOffices({
        module: "getCoeReportOffices",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          office_ids: officeIds,
          limit: officeCounter,
          stat: statusAPI,
          rea_ids: reaIds,
          manager_ids: managerIds,
        },
      })
    );
  };

  const getManagerData = () => {
    // GET MANAGER DATA
    dispatch(
      getCoeManagers({
        module: "getCoeReportManagers",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          limit: managerCounter,
          office_ids: officeIds,
          stat: statusAPI,
          rea_ids: reaIds,
          manager_ids: managerIds,
        },
      })
    );
  };

  function formatDate(inputDate) {
    // const dateParts = inputDate.split("/");

    // // Check if the date format is valid
    // if (dateParts.length !== 3) {
    //   return "";
    // }

    // const formattedDate = new Date(
    //   `${dateParts[2]}-${dateParts[0]}-${dateParts[1]}`
    // );

    // if (isNaN(formattedDate.getTime())) {
    //   return "";
    // }

    // const day = formattedDate.getDate();
    // const monthNames = [
    //   "Jan",
    //   "Feb",
    //   "Mar",
    //   "Apr",
    //   "May",
    //   "Jun",
    //   "Jul",
    //   "Aug",
    //   "Sep",
    //   "Oct",
    //   "Nov",
    //   "Dec",
    // ];
    // const monthIndex = formattedDate.getMonth();
    // const year = formattedDate.getFullYear();

    // const formattedString = `${day} ${monthNames[monthIndex]}, ${year}`;

    // return formattedString;
    let formattedDate = "-";
    if (inputDate) {
      formattedDate = moment(inputDate, "MM/DD/YYYY").format("MMM DD, YYYY");
    }
    return formattedDate;
  }

  const ExportToExcel = () => {
    const data = _.cloneDeep(usageReports);
    console.log("data for excel", data);
    // for (let item of data) {
    //     item.status =
    //         item?.status === "Active"
    //             ? "Active"
    //             : item?.status === "Not Verify"
    //                 ? "Not Verify"
    //                 : "Expired";
    // }

    let tempArr = [];
    for (const item of data) {
      let officeNames = item.office.join(", ");
      let obj = {
        "first name": item.first_name,
        "last name": item.last_name,
        role:
          item?.role === "Real Estate Agent" || item?.role === "Participant"
            ? "End user"
            : item?.role === "Manager"
            ? "Team Manager"
            : item?.role === "External Instructor"
            ? "External Trainer"
            : item?.role,
        email: item.user_email,
        office_name: officeNames,
        manager: item.manager,
        status: item.status,
        "last logged in": item.last_login ? formatDate(item.last_login) : "-",
        "user created date": item.created_at
          ? formatDate(item.created_at)
          : "-",
        // "user activation date": item.activation_date
        //   ? formatDate(item.activation_date)
        //   : "-",
        "date of joining": item.date_of_joining
          ? formatDate(item.date_of_joining)
          : "-",
        // "hire source": item.hire_source,
        // remarks: item.remarks,
      };
      tempArr.push(obj);
    }

    const newThing = [];
    tempArr.map((item) => {
      newThing.push(
        _.mapKeys(item, (value, key) => {
          switch (key) {
            case "first name":
              return "First Name";
            case "last name":
              return "Last name";
            case "role":
              return "Role";
            case "email":
              return "Email";
            case "office_name":
              return officeLabel;
            // case "manager":
            //   return "Team Manager";
            case "status":
              return "Status";
            case "last logged in":
              return "Last Logged In Date";
            case "user created date":
              return "User Created Date";
            // case "user activation date":
            //   return "User Activation Date";
            case "date of joining":
              return "Date of Hiring";
            // case "hire source":
            //   return "Hire Source";
            // case "remarks":
            //   return "Remarks";
            default:
              return;
          }
        })
      );
    });

    for (let i = 0; i < newThing.length; i++) {
      // arrayObj[i].stroke = arrayObj[i]['key1'];
      delete newThing[i].undefined;
    }

    for (let i = 0; i < data.length; i++) {
      // arrayObj[i].stroke = arrayObj[i]['key1'];
      delete data[i]._id;
    }
    // console.log('data:', data)
    // exportFromJSON({ data, fileName, exportType })

    //For mobile
    let tempObj = {
      method: "SystemUsageReport",
      report: newThing,
    };
    if (window.callbackHandler != undefined) {
      window.callbackHandler.postMessage(JSON.stringify(tempObj));
    } else if (window.webkit != undefined) {
      if (window.webkit.messageHandlers.callbackHandler != undefined) {
        window.webkit.messageHandlers.callbackHandler.postMessage(
          JSON.stringify(tempObj)
        );
      }
    }

    const worksheet = XLSX.utils.json_to_sheet(newThing);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, fileName + ".xlsx");
  };

  const searchTable = (searchVal) => {
    console.log("searched value", searchVal);
    let list = _.cloneDeep(usageReportsFilter);
    console.log(list, searchVal);
    if (searchVal === "") {
      setUsageReports(list);
      return;
    }

    let filterBySearch = [];
    for (const item of list) {
      if (
        item?.first_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.last_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.user_email?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.role?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.manager?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.hire_source?.toLowerCase().includes(searchVal.toLowerCase())
      ) {
        filterBySearch.push(item);
      }
    }
    console.log("filterBySearch: ", filterBySearch);

    setUsageReports(filterBySearch);
  };

  const handleClick = () => {
    window.scrollTo(0, 450);
  };

  return (
    <>
      <Loader start={isLoading} />
      <section className="reports-header mt-2rem">
        <div className="container-pwc">
          <div className="row">
            <div className="col-md-12 text-start mb-4">
              {JSON.parse(backbutton) ? (
                ""
              ) : (
                <button
                  type="button"
                  id="backbtnreport"
                  className="btn btn-primary-complete bckbtn m-0"
                  onClick={() => {
                    dispatch(getSavedFilterDataResponseClearById());
                    let obj = { message: "backButton" };
                    if (isMobile) {
                      window.parent.postMessage(
                        JSON.stringify(obj),
                        "*"
                      );
                      window.parent.postMessage(
                        JSON.stringify(obj),
                        "*"
                      );
                    } else {
                      navigate(-1);
                    }
                    if (isAndroid || isIOS) {
                      try {
                        if (window.callbackHandler != undefined) {
                          window.callbackHandler.postMessage("backButton");
                        }
                        if (window.webkit != undefined) {
                          if (
                            window.webkit.messageHandlers.callbackHandler !=
                            undefined
                          ) {
                            window.webkit.messageHandlers.callbackHandler.postMessage(
                              "backButton"
                            );
                          }
                        }
                      } catch (err) {
                        console.log("error in sending message");
                      }
                    }
                  }}
                >
                  {t("back")}
                </button>
              )}
            </div>
            <div className="col-md-12">
              <div className="reports-head-main">{t("reports")}</div>
            </div>

            <div className="col-md-12 d-flex justify-content-between dropbox-section">
              <ReportHeaderComponent
                title={t("System Usage Report")}
                isFilterExpand={isExpand}
                setIsFilterExpand={setIsExpand}
                exportReport={ExportToExcel}
              />
              <ReportExportButtonComponent exportReport={ExportToExcel} />
            </div>
            <div className="col-md-12">
              {isExpand && (
                <ReportFiltersComponent
                  setSelectedFilters={setSelectedFilters}
                  selectedFiltersFromDashboard={
                    savedFiltersDataById?.filter_content
                      ? savedFiltersDataById?.filter_content
                      : ""
                  }
                  setIsExpand={setIsExpand}
                  handleClick={handleClick}
                  isMobile={isMobile}
                  showFilters={showFilters}
                  hideOverDueStatus={true}
                  reportType={"system_usage_report"}
                />
              )}
            </div>
          </div>
        </div>
      </section>
      {/* {false && <section className="progress-report-data">
                <div className="container">
                    <DonutTrendChartComponent
                        blockTitle={''}
                        dropDownLabel={'Select Year'}
                        dropDownArray={filterYearData}
                        selectDropDown={setTrendYear}
                        loader={imgLoader}
                        setLoader={setImgLoader}
                        donutTitle={'Completion Status'}
                        series={series}
                        legends={legends}
                        selectedTitle={'2023'}
                        trendTitle={'Code of Ethics Completion Trend'}
                        trendValues={crsCompltTrendValues}
                        useTrendValues={true}
                        completionTrendYAxisLabel={'Agents Completed'}
                    />
                </div>
            </section>} */}
      {/* <div id="myOnboard" class="center_line"></div>

            <OfficeSectionCoe
                isMobile={isMobile}
                counter={officeCounter}
                setCounter={setOfficeCounter}
            />

            <ManagerReportSecCoe
                isMobile={isMobile}
                counter={managerCounter}
                setCounter={setManagerCounter}
            /> */}

      {/* <section className="progress-box-report">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 flex-titlereport d-flex justify-content-between align-items-baseline">
                            <div className="progess-count-tiel">
                                Real Estate Agents&nbsp;
                                <strong>({totalRea?.total_rea})</strong> - Cumulative Progress of an Agent
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        {(!_.isEmpty(reaList)) ? reaList?.map((m, index) => {
                            return (
                                <div
                                    className="col-md-6 col-lg-4 col-xl-3 col-12 mb-report"
                                    key={index}
                                >
                                    <div className="reopor-box-progess">
                                        <div className="progess-profile d-flex">
                                            <div className="user-progess-img">
                                                <img src={m?.profile_pic} width="48" height="48" />
                                            </div>
                                            <div className={`userprogress-details ${(m?.is_allow === true && false) ? "cursor-pointer" : "cursor-not-allowed"}`}>
                                                <h5
                                                    className="user-tiele"
                                                    onClick={() => {
                                                        if (m?.is_allow === true && false) {
                                                            navigate(`/profile/edit?section=edit&user_id=${m?.uid}&isOther=1`);
                                                        }
                                                    }}
                                                >
                                                    {m?.user_name}
                                                </h5>
                                                <OverlayTrigger
                                                    key='bottom'
                                                    placement='bottom'
                                                    overlay={
                                                        <Tooltip id={`tooltip-bottom`}>
                                                            <div
                                                                style={{
                                                                    color: "white",
                                                                    backgroundColor: "transparent",
                                                                }}

                                                            >{m?.office_name}</div>
                                                        </Tooltip>
                                                    }
                                                >
                                                    <p >{m?.office_name}</p>
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                        <hr />
                                        <div class="progress-details cod-progress">
                                            <div class="progess-report-graph">
                                                <div class="circlebox">
                                                    <div
                                                        className="circularProgress-sm"
                                                        style={{
                                                            width: 72,
                                                            height: 72,
                                                            position: "relative",
                                                        }}
                                                    >
                                                        <CircularProgressbar
                                                            value={m?.learning_percentage}
                                                            strokeWidth={8}
                                                            styles={buildStyles({
                                                                pathColor: "#415385", 
                                                                trailColor: "#EBEBEB",
                                                            })
                                                            }
                                                        />
                                                        <div className="centerprogess-con"
                                                            style={{
                                                                position: "absolute",
                                                                top: "1.2rem",
                                                                width: "72px",
                                                                textAlign: "center",
                                                            }}
                                                        >
                                                            {true ? (
                                                                <>
                                                                    <strong
                                                                        style={{ color: "#415385" }}
                                                                    >{`${m?.learning_percentage}%`}</strong>
                                                                    <small>Progress</small>
                                                                </>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="progess-count-show-new">
                                                <div class="learning-points-new">
                                                    <strong>{m?.completed_checkList}/</strong>{m?.total_checkList}
                                                </div>
                                                <div class="learning-points-name">
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            );
                        }) : loadSpin && counter === 1 ?
                            <div className="not-found mt-3">
                                <div className="interboxes">
                                    <Spinner animation="border" />
                                </div>
                            </div>
                            :
                            <div className="col-md-12">
                                <div className="not-found mt-3">
                                    <div className="interboxes">
                                        <img src="/images/finwell-img/NoSearchResults.svg" alt="Not Found" />
                                        <p>This section will display the REA's that have to complete the Code of Ethics.</p>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="col-md-12 mt-3">
                           
                            <p className="text-center">
                                {reaList?.length === 0 || (totalRea?.total_rea === reaList?.length) ? "" : (totalRea?.total_rea < 4) ? "" :
                                    <button
                                        type="button"
                                        id="number"
                                        className="btn btn-primary-complete"
                                        onClick={() => {
                                            setCount(counter, setCounter);
                                            setLoadSpin(true);
                                        }}
                                    >
                                        {(loadSpin) ?
                                            <div className="d-flex justify-content-center w-100">
                                                <Spinner animation="border" />
                                            </div>
                                            : "Load More"}
                                    </button>
                                }
                            </p>
                        </div>
                    </div>
                </div>
            </section> */}
      {/* <RealEstateAgentsReportSection overAllData={overAllData} /> */}

      <div id="myOnboard" class="center_line"></div>
      <div className="system-usage-table">
        <ReportTableSystemUsage
          setSearchInput={""}
          getFilteredData={[]}
          lpName={"Onboarding Name"}
          isView={isView}
          // statusFilterData={statusFilterData}
          setCanShow={setCanShow}
          profileReports={usageReports}
          currentTableData={currentTableData}
          type={type}
          message={t(
            "This section will display the Participants and Managers added."
          )}
          searchTable={searchTable}
        />
      </div>
      <ConfirmModal
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        showModalMsg={`Client is mandatory, please select first.`}
        //   ${
        //   officeLabel == "Office Name" ? "Office(s)" : officeLabel
        // }

        isConfirm={false}
        confirmId={""}
        confirmAction={""}
        isRightIcon={false}
        isMobile={isMobile}
      />
    </>
  );
};

export default SystemUsageReportHomeSection;
